import React from 'react'; // eslint-disable-line
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Header, Segment } from 'semantic-ui-react';
import { formatCentAmount, formatDate } from '../../lib/formatters.js';
import './employee-stipend-details.css';

const EmployeeStipendDetails = (props) => {
  if (!props.employeeStipends) return null;

  if (props.employeeStipends.length === 0)
    return (
      <div className="card stipend-details">
        <Header as="h2" attached="top">{props.header}</Header>
        <Segment attached="bottom" className="stipend-empty-state">
          <p>No stipends currently available</p>
        </Segment>
      </div>
    );

  return (
    <div className="card stipend-details">
      <Header as="h2" attached="top">{props.header}</Header>
      <Segment attached="bottom" className="stipend-details-container">
        {props.employeeStipends.map((stipend, index) => {
          return (
            <div key={stipend.id || index} className="stipend-section">
              <h3>{stipend.stipend_name}</h3>
              <div className="section-description">
                Stipend balance and expiration details
              </div>
              <div className="stipend-info">
                <div className="info-item">
                  <span className="label">Available Balance:</span>
                  <span className="value balance">
                    {formatCentAmount(stipend.stipend_remaining)}
                  </span>
                </div>
                <div className="info-item">
                  <span className="label">Initial Amount:</span>
                  <span className="value">
                    {formatCentAmount(stipend.amount)}
                  </span>
                </div>
                <div className="info-item">
                  <span className="label">Expires:</span>
                  <span className="value">
                    {formatDate(stipend.expires_at)}
                  </span>
                </div>
              </div>
            </div>
          );
        })}
      </Segment>
    </div>
  );
};

EmployeeStipendDetails.propTypes = {
  employeeStipends: PropTypes.object.isRequired,
  header: PropTypes.string,
};

EmployeeStipendDetails.defaultProps = {
  header: 'Your Stipend Details',
};

export function mapStateToProps(state) {
  const sourceEmployeeStipends = state.employees.user.employee_stipends;
  let employeeStipends = null;
  if (sourceEmployeeStipends) {
    employeeStipends = sourceEmployeeStipends;
  }
  return {
    employeeStipends: employeeStipends,
  };
}

export function areStatesEqual(prev, next) {
  return (
    prev.auth.role === next.auth.role && prev.carts.open === next.carts.open
  );
}

export default connect(mapStateToProps, null, null, { areStatesEqual })(
  EmployeeStipendDetails
);
